import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import Certifications from 'pages/Certifications';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavbarMenu from 'components/NavbarMenu';
import CaptureTheFlags from 'pages/CaptureTheFlags';
import Extras from 'pages/Extras';

ReactDOM.render(
    <BrowserRouter>
    <NavbarMenu />
    <Routes>
      <Route path='*' element={<App />} />
      <Route path="/mybio" element={<App />} />
      <Route path='/Certifications' element={<Certifications />} />
      <Route path='/CTFs' element={<CaptureTheFlags />} />
      <Route path='/extras' element={<Extras />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById('root')
);